export default __webpack_public_path__ + "static/media/Featured.dcea86c1.svg";